// // import "./TechLoader.css";

// // export default function TechLoader() {
// //     return (
// //         <div className="tech-loader">
// //             <div className="code-line">
// //                 <span className="bracket">&lt;</span>
// //                 <span className="typing">Building Digital Experience</span>
// //                 <span className="cursor">|</span>
// //                 <span className="bracket">/&gt;</span>
// //             </div>

// //             <div className="services">
// //                 <span>Web Development</span>
// //                 <span>SEO Optimization</span>
// //                 <span>Graphic Designing</span>
// //             </div>
// //         </div>
// //     );
// // }
// import "./TechLoader.css";

// const TechLoader = () => {
//     return (
//         <div className="tech-loader">
//             {/* Animated grid background */}
//             <div className="tech-loader__grid" />

//             {/* Floating tech icons */}
//             <div className="tech-loader__icons">
//                 {/* Code brackets */}
//                 <div className="tech-loader__icon tech-loader__icon--1">
//                     <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                         <polyline points="16 18 22 12 16 6" />
//                         <polyline points="8 6 2 12 8 18" />
//                     </svg>
//                 </div>
//                 {/* Palette */}
//                 <div className="tech-loader__icon tech-loader__icon--2">
//                     <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                         <circle cx="13.5" cy="6.5" r="0.5" fill="currentColor" />
//                         <circle cx="17.5" cy="10.5" r="0.5" fill="currentColor" />
//                         <circle cx="8.5" cy="7.5" r="0.5" fill="currentColor" />
//                         <circle cx="6.5" cy="12.5" r="0.5" fill="currentColor" />
//                         <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" />
//                     </svg>
//                 </div>
//                 {/* Search/SEO */}
//                 <div className="tech-loader__icon tech-loader__icon--3">
//                     <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                         <circle cx="11" cy="11" r="8" />
//                         <line x1="21" y1="21" x2="16.65" y2="16.65" />
//                         <line x1="11" y1="8" x2="11" y2="14" />
//                         <line x1="8" y1="11" x2="14" y2="11" />
//                     </svg>
//                 </div>
//                 {/* Video */}
//                 <div className="tech-loader__icon tech-loader__icon--4">
//                     <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                         <polygon points="23 7 16 12 23 17 23 7" />
//                         <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
//                     </svg>
//                 </div>
//             </div>

//             {/* Central spinner */}
//             <div className="tech-loader__center">
//                 <div className="tech-loader__ring tech-loader__ring--outer" />
//                 <div className="tech-loader__ring tech-loader__ring--middle" />
//                 <div className="tech-loader__ring tech-loader__ring--inner" />
//                 <div className="tech-loader__logo">S</div>
//             </div>

//             {/* Typing text */}
//             <div className="tech-loader__text">
//                 <span className="tech-loader__label">Building your experience</span>
//                 <span className="tech-loader__dots">
//                     <span className="tech-loader__dot">.</span>
//                     <span className="tech-loader__dot">.</span>
//                     <span className="tech-loader__dot">.</span>
//                 </span>
//             </div>

//             {/* Progress bar */}
//             <div className="tech-loader__progress">
//                 <div className="tech-loader__progress-bar" />
//             </div>
//         </div>
//     );
// };


// ______________________Second layout______________________

import "./TechLoader.css";
import { useEffect, useState } from "react";

const TechLoader = () => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prev) => {
                if (prev >= 100) {
                    clearInterval(interval);
                    return 100;
                }
                return prev + 1; // speed control
            });
        }, 25); // ← loading speed (lower = faster)

        return () => clearInterval(interval);
    }, []);
    return (
        <div className="tech-loader">

            <div className="tech-loader__grid" />

            <div className="tech-loader__icons">

                <div className="tech-loader__icon tech-loader__icon--1">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="16 18 22 12 16 6" />
                        <polyline points="8 6 2 12 8 18" />
                    </svg>
                </div>

                <div className="tech-loader__icon tech-loader__icon--2">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="13.5" cy="6.5" r="0.5" fill="currentColor" />
                        <circle cx="17.5" cy="10.5" r="0.5" fill="currentColor" />
                        <circle cx="8.5" cy="7.5" r="0.5" fill="currentColor" />
                        <circle cx="6.5" cy="12.5" r="0.5" fill="currentColor" />
                        <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" />
                    </svg>
                </div>
                <div className="tech-loader__icon tech-loader__icon--3">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="11" cy="11" r="8" />
                        <line x1="21" y1="21" x2="16.65" y2="16.65" />
                        <line x1="11" y1="8" x2="11" y2="14" />
                        <line x1="8" y1="11" x2="14" y2="11" />
                    </svg>
                </div>
                <div className="tech-loader__icon tech-loader__icon--4">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polygon points="23 7 16 12 23 17 23 7" />
                        <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
                    </svg>
                </div>
            </div>

            <div className="tech-loader__center">
                <div className="tech-loader__ring tech-loader__ring--outer" />
                <div className="tech-loader__ring tech-loader__ring--middle" />
                <div className="tech-loader__ring tech-loader__ring--inner" />
                <div className="tech-loader__logo">S</div>
            </div>

            {/* <div className="tech-loader__text">
                <span className="tech-loader__label">Building your experience</span>
                <span className="tech-loader__dots">
                    <span className="tech-loader__dot">.</span>
                    <span className="tech-loader__dot">.</span>
                    <span className="tech-loader__dot">.</span>
                </span>
            </div> */}
            <div className="tech-loader__text">
                <span className="tech-loader__label">
                    Building your experience {progress}%
                </span>
            </div>

            {/* <div className="tech-loader__progress">
                <div className="tech-loader__progress-bar" />
            </div> */}

            <div className="tech-loader__progress">
                <div
                    className="tech-loader__progress-bar"
                    style={{ width: `${progress}%` }}
                />
            </div>
        </div>
    );
};

export default TechLoader;


// ______________________Third Layout______________________

// src/components/TechLoader/TechLoader.jsx

// import React from "react";
// import "./TechLoader.css";
// import SwastiqLogo from "./../Assets/swastiwLogo.png"

// export default function TechLoader() {
//     return (
//         <div className="loader-container">
//             {/* Subtle Grid Background */}
//             <div className="grid-pattern" />

//             {/* Subtle Decorative Gradient Orbs */}
//             <div className="gradient-orb top-right" />
//             <div className="gradient-orb bottom-left" />

//             {/* Main Content */}
//             <div className="content-wrapper">
//                 {/* Logo / Symbol */}
//                 <div className="logo-container">
//                     {/* <div className="logo-circle logo-glow">
//                         <span className="material-symbols-outlined symbol">
//                             S
//                         </span>
//                     </div> */}

//                     <img src={SwastiqLogo} alt="" className="log-loading-page" />
//                     {/* Decorative nodes */}
//                     <div className="node top-right-node" />
//                     <div className="node bottom-left-node" />
//                     <div className="node right-pulse animate-pulse" />
//                 </div>

//                 {/* Text Content */}
//                 <div className="text-content">
//                     <h1 className="title">
//                         Swastiq Tech <span className="highlight">Designs</span>
//                     </h1>

//                     <p className="tagline">
//                         Crafting Digital Solutions with Quality and Innovation
//                     </p>

//                     {/* Values pills */}
//                     <div className="values-row">
//                         <div className="value-item active">
//                             <span className="dot active-dot" />
//                             <span className="label">PRECISION</span>
//                         </div>
//                         <div className="value-item">
//                             <span className="dot" />
//                             <span className="label">INNOVATION</span>
//                         </div>
//                         <div className="value-item">
//                             <span className="dot" />
//                             <span className="label">EXCELLENCE</span>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Footer accents */}
//             <div className="footer-accents">
//                 <div className="icons-row">
//                     {/* <span className="material-symbols-outlined">blur_on</span>
//                     <span className="material-symbols-outlined">grid_view</span>
//                     <span className="material-symbols-outlined">all_out</span> */}
//                 </div>
//                 <p className="premium-text">PREMIUM • MINIMAL • PROFESSIONAL</p>
//             </div>

//             {/* Concentric tech rings */}
//             <div className="rings-container">
//                 <div className="ring ring-1" />
//                 <div className="ring ring-2" />

//                 <div className="ring ring-3">
//                     <div className="tool-icon seo">
//                         <span className="material-symbols-outlined">
//                             <svg width="64" height="64" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
//                                 <circle cx="64" cy="20" r="18" fill="#F24E1E" />
//                                 <circle cx="64" cy="64" r="18" fill="#A259FF" />
//                                 <circle cx="64" cy="108" r="18" fill="#1ABCFE" />
//                                 <circle cx="28" cy="20" r="18" fill="#FF7262" />
//                                 <circle cx="28" cy="64" r="18" fill="#0ACF83" />
//                             </svg>
//                         </span>
//                     </div>
//                     <div className="tool-icon database">
//                         <span className="material-symbols-outlined">
//                             <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" stroke-width="2" xmlns="http://www.w3.org/2000/svg">
//                                 <ellipse cx="12" cy="5" rx="9" ry="3" />
//                                 <path d="M3 5v6c0 1.7 4 3 9 3s9-1.3 9-3V5" />
//                                 <path d="M3 11v6c0 1.7 4 3 9 3s9-1.3 9-3v-6" />
//                             </svg>
//                         </span>
//                     </div>
//                 </div>

//                 <div className="ring ring-4" />


//                 <div className="ring ring-5" />


//                 <div className="ring ring-6">
//                     <div className="tool-icon react">
//                         <span className="material-symbols-outlined">
//                             <svg width="30" height="30" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg" >
//                                 <rect width="128" height="128" fill="#F7DF1E" />
//                                 <path d="M34 107l10-6c2 4 4 7 9 7 4 0 7-2 7-8V56h12v45c0 14-8 20-19 20-10 0-16-5-19-14zm54-1c3 5 7 9 14 9 6 0 10-3 10-7 0-5-4-7-11-10l-4-2c-12-5-20-11-20-23 0-11 9-19 22-19 10 0 16 3 21 12l-11 7c-2-4-5-6-10-6s-8 3-8 7c0 5 3 7 10 10l4 2c14 6 22 12 22 24 0 14-11 21-25 21-14 0-23-6-27-15z" />
//                             </svg>
//                         </span>
//                     </div>
//                     <div className="tool-icon php">
//                         <span className="material-symbols-outlined">
//                             <svg width="64" height="64" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">


//                                 <path d="M48 36a12 12 0 0 0-23.6-4A8 8 0 0 0 16 36c0 4.4 3.6 8 8 8h24c3.3 0 6-2.7 6-6s-2.7-6-6-6z" />


//                                 <rect x="24" y="38" width="16" height="8" rx="2" fill="currentColor" />
//                                 <line x1="24" y1="42" x2="40" y2="42" stroke="#fff" stroke-width="1" />
//                             </svg>
//                         </span>
//                     </div>
//                     <div className="tool-icon js">
//                         <span className="material-symbols-outlined">
//                             <svg width="64" height="64" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
//                                 <rect width="70" height="70" rx="18" fill="#001E36" />
//                                 <text x="12" y="50" font-size="40" font-family="Arial" fill="#31A8FF" font-weight="bold">
//                                     Ps
//                                 </text>
//                             </svg>
//                         </span>
//                     </div>
//                     <div className="tool-icon css">
//                         <span className="material-symbols-outlined">
//                             <svg width="64" height="64" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
//                                 <g fill="none" stroke="#61DAFB" stroke-width="10">
//                                     <ellipse cx="128" cy="128" rx="90" ry="36" />
//                                     <ellipse cx="128" cy="128" rx="90" ry="36" transform="rotate(60 128 128)" />
//                                     <ellipse cx="128" cy="128" rx="90" ry="36" transform="rotate(120 128 128)" />
//                                 </g>
//                                 <circle cx="128" cy="128" r="18" fill="#61DAFB" />
//                             </svg>
//                         </span>
//                     </div>
//                 </div>

//                 <div className="ring ring-7" />
//                 <div className="ring ring-8" />
//             </div>
//         </div >
//     );
// }
